// extracted by mini-css-extract-plugin
export default {"fitContainer":"TR-z","label":"UR-z","selectField":"VR-z","select":"WR-z","disabled":"XR-z","archField":"YR-z"};